const toggle = ($item) => {
  $item.classList.toggle('qa__item--open');
};

const handleClick = (event) => {
  toggle(event.currentTarget.parentElement);
};

const handleKeydown = (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    toggle(event.currentTarget.parentElement);
  }
};

document.querySelectorAll('.qa__item__title').forEach(($title) => {
  $title.addEventListener('click', handleClick);
  $title.addEventListener('keydown', handleKeydown);
});
